class TurnstileWidgetDirective implements angular.IDirective {
    restrict = 'E';
    scope = {
        onVerified: '&',
        onError: '&',
        onExpired: '&',
        isEnabled: '='
    };
    template = '<div id="turnstile-widget-{{::$id}}" ng-show="isEnabled"></div>';

    static $inject = ['TurnstileService'];
    constructor(private TurnstileService: any) {}

    link = (scope: any, element: any) => {
        var widgetId: string | null = null;
        var containerId = `turnstile-widget-${scope.$id}`;

        if (!scope.isEnabled) {
            return;
        }

        this.TurnstileService.getConfig().then((config: { siteKey: string; enabled: boolean }) => {
            if (!config.enabled || !config.siteKey) {
                scope.isEnabled = false;
                return;
            }

            this.TurnstileService.loadScript().then(() => {
                widgetId = this.TurnstileService.renderWidget(containerId, config.siteKey, {
                    onVerified: (token: string) => {
                        scope.$apply(() => {
                            scope.onVerified({ token: token });
                        });
                    },
                    onError: () => {
                        scope.$apply(() => {
                            scope.onError();
                        });
                    },
                    onExpired: () => {
                        scope.$apply(() => {
                            scope.onExpired();
                        });
                    }
                });
            });
        });

        scope.$on('$destroy', () => {
            if (widgetId) {
                this.TurnstileService.removeWidget(widgetId);
                widgetId = null;
            }
        });

        scope.$on('turnstile:reset', () => {
            if (widgetId) {
                this.TurnstileService.resetWidget(widgetId);
            }
        });
    };
}

angular
    .module('app')
    .directive('turnstileWidget', ['TurnstileService', (TurnstileService: any) => new TurnstileWidgetDirective(TurnstileService)]);
